<template>
  <div>
    <div class="form-group">
      <h3>Prijava problema opcije</h3>
      <label for="exampleFormControlSelect1"
        >View available options for known problems</label
      >

      <ul class="list-group">
        <li class="list-group-item" v-for="(o, index) in units" :key="o.index">
          {{ o }}
          <span class="btn btn-danger" @click="deleteUnit(index)">Obrisi</span>
        </li>
      </ul>

      <label for="units">Dodaj novi termin za prijavu problem</label>
      <input
        id="units"
        type="text"
        class="form-control"
        placeholder="Dodaj novi termin za prijavu problem"
        v-model="unit"
      />
      <button class="btn btn-success mt-2" @click="addUnit">
        Dodaj
      </button>
    </div>
    <button class="btn btn-primary mt-4" @click="saveChanges">
      Sacuvaj izmjene
    </button>
  </div>
</template>
<script>
export default {
  data() {
    return {
      units: {},
      unit: ""
    };
  },
  created() {
    if (this.getOptions) {
      this.units = this.getOptions.knownProblems;
    }
  },
  methods: {
    deleteUnit(index) {
      this.units.splice(index, 1);
    },
    addUnit() {
      this.units.push(this.unit);
    },
    saveChanges() {
      this.getOptions.knownProblems = this.units;
      const updatedKnownProblems = {
        prevOpt: this.getOptions
      };
      this.$store.dispatch("updatedAllOptions", updatedKnownProblems);
    }
  },
  computed: {
    getOptions() {
      return this.$store.getters.getOptions;
    }
  }
};
</script>
<style></style>
